import CryptoJS from 'crypto-js';

const SECRET_KEY = process.env.SECRET_KEY;

/**
 * AES-256 CBC PKCS#5Padding 복호화 함수
 * @param {string} encryptedBase64 - 서버로부터 받은 Base64(IV + CipherText)
 * @param {string} secretKey - 32바이트 길이의 키 문자열
 * @returns {string} 복호화된 평문
 */
export function decryptAes256(encryptedBase64, secretKey) {
  const useSecretKey = secretKey || SECRET_KEY;

  // Base64 디코딩
  const rawData = CryptoJS.enc.Base64.parse(encryptedBase64);

  // rawData는 IV(16바이트) + CipherText 구조
  // WordArray 단위로 접근: WordArray는 32비트(4바이트) 1워드
  // IV 16바이트 = 4워드
  const ivWords = rawData.words.slice(0, 4);
  const cipherWords = rawData.words.slice(4);

  // IV, CipherText WordArray 생성
  const ivBytes = CryptoJS.lib.WordArray.create(ivWords, 16);
  const cipherBytes = CryptoJS.lib.WordArray.create(cipherWords, rawData.sigBytes - 16);

  // 키 파싱 (32바이트)
  const keyBytes = CryptoJS.enc.Utf8.parse(useSecretKey);

  // 복호화
  const decrypted = CryptoJS.AES.decrypt(
    { ciphertext: cipherBytes },
    keyBytes,
    {
      iv: ivBytes,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7
    }
  );

  return decrypted.toString(CryptoJS.enc.Utf8);
}

/**
 * AES-256 CBC PKCS#5Padding 암호화 함수
 * @param {string} plainText - 암호화할 평문
 * @param {string} secretKey - 32바이트 길이의 키 문자열
 * @returns {string} Base64로 인코딩된 IV + CipherText
 */
export function encryptAes256(plainText, secretKey) {
  const useSecretKey = secretKey || SECRET_KEY;

  // 키 파싱 (32바이트)
  const keyBytes = CryptoJS.enc.Utf8.parse(useSecretKey);

  // IV 16바이트 랜덤 생성
  const ivBytes = CryptoJS.lib.WordArray.random(16);

  // 암호화
  const encrypted = CryptoJS.AES.encrypt(plainText, keyBytes, {
    iv: ivBytes,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  // IV + CipherText 합쳐서 Base64로 인코딩
  const combined = ivBytes.concat(encrypted.ciphertext);
  return CryptoJS.enc.Base64.stringify(combined);
}



// WEBPACK FOOTER //
// ./src/utils/aesEncryptionUtil.js